export default "__VITE_ASSET__UXuAEZrq__"